import { Dialog, DialogContent, DialogProps, DialogTitle } from '@material-ui/core';
import { Form, Formik, FormikHelpers } from 'formik';
import { CancelSubmitFormDialogActions } from 'framework/forms/CancelSubmitFormDialogActions';
import { FormTextField } from 'framework/forms/FormTextField';
import { handleFormResponse } from 'framework/forms/utils/handleFormResponse';
import { useFormSubmit } from 'framework/hooks/useFormSubmit';
import { useSnackbarNotify } from 'framework/hooks/useSnackbarNotify';
import { IPatchPatientOriginalNoRequest, IPatient, patientsCommand_patchOriginalPatientNo } from 'gen/ApiClient';
import { IStrings } from 'localization/IStrings';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import * as yup from 'yup';

const createSchema = (strings: IStrings) => {
	return yup.object<IPatchPatientOriginalNoRequest>({
		originalNo: yup.string().required(strings.formRequired(strings.reference)),
		patientId: yup.string().required(),
	});
};

interface IProps extends DialogProps {
	patient: IPatient;
	confirm: VoidFunction;
	cancel: VoidFunction;
}

export const PatchPatientOriginalNoRequestForm = ({ patient, confirm, cancel, ...rest }: IProps) => {
	const strings = useLocalization();
	const notify = useSnackbarNotify();
	const [update, isSubmitting] = useFormSubmit(patientsCommand_patchOriginalPatientNo);

	const handleSubmit = async (values: IPatchPatientOriginalNoRequest, helpers: FormikHelpers<IPatchPatientOriginalNoRequest>) => {
		const r = await update(values);
		if (handleFormResponse(r, helpers)) {
			notify(strings.patientUpdated);
			confirm();
		}
	};

	return (
		<Formik<IPatchPatientOriginalNoRequest>
			validateOnMount
			validationSchema={createSchema(strings)}
			initialValues={{
				originalNo: patient.originalPatientNo ?? '',
				patientId: patient.id,
			}}
			onSubmit={handleSubmit}>
			<Form>
				<Dialog
					fullWidth
					{...rest}>
					<DialogTitle>{strings.numbering}</DialogTitle>
					<DialogContent
						dividers
						className='df-col'
						style={{ overflow: 'visible' }}>
						<FormTextField<IPatchPatientOriginalNoRequest>
							label={strings.numbering}
							name='originalNo'
						/>
					</DialogContent>
					<CancelSubmitFormDialogActions
						submitText={strings.update}
						isSubmitting={isSubmitting}
						cancel={cancel}
					/>
				</Dialog>
			</Form>
		</Formik>
	);
};
